/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import {
    IArubaRemoteSignRequest, IField, IFile, ILog, IProtocol, IQueryCriteriaEF, IVisibilita, IAnnotazione,
    IForwardRulesEvaluationResult
} from "../shared/interfaces";
import { IVisibilitaDTO, IProtocolsSearchPageResult, IProtocolSavePayload } from "../shared/interfacesDTO";
import Utilities from "../shared/Utilities/utilities";




const getProtocolsUor = (aooId: number, uorId: number, queryCriteria: IQueryCriteriaEF, cancelToken?: CancelToken): Promise<IProtocolsSearchPageResult> => {
    return axiosInstance.post(`Protocols/${aooId}/GetProtocolsUor`, queryCriteria, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getProtocol = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`Protocols/${aooId}/GetProtocol/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getProtocolDocumentFile = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IFile> => {

    return axiosInstance.get(`Protocols/${aooId}/GetProtocolDocumentFile/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(response => convertFileSPToIFile(response.data))
        .catch(error => {
            return Promise.reject(error);
        });
}
const getFileByName = (aooId: number, uorId: number | undefined, protocolId: number, filename: string, cancelToken?: CancelToken): Promise<IFile> => {

    return axiosInstance.get(`Protocols/${aooId}/GetFileByName/${protocolId}`, { params: { uorId: uorId, filename: filename }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getFileById = (aooId: number, uorId: number | undefined, protocolId: number, fileId: number, cancelToken?: CancelToken): Promise<IFile> => {

    return axiosInstance.get(`Protocols/${aooId}/GetFileById/${protocolId}/${fileId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getProtocolFilesAsZip = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IFile> => {
    return axiosInstance.get(`Protocols/${aooId}/GetProtocolFilesAsZip/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAudit = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<ILog[]> => {

    return axiosInstance.get(`Protocols/${aooId}/GetAudit/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getSummaryIA = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<string> => {

    return axiosInstance.get(`Protocols/${aooId}/GetSummaryIA/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getVisibilitaProtocollo = (aooId: number, protocolId: number, cancelToken?: CancelToken): Promise<IVisibilita[]> => {
    return axiosInstance.get(`Protocols/${aooId}/GetVisibilitaProtocollo/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getUserVisibilitaForProtocol = (aooId: number, protocolId: number, cancelToken?: CancelToken): Promise<IVisibilita[]> => {
    return axiosInstance.get(`Protocols/${aooId}/GetUserVisibilitaForProtocol/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const evaluateProtocolForwardRules = (aooId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<IForwardRulesEvaluationResult> => {
    return axiosInstance.post(`Protocols/${aooId}/EvaluateProtocolForwardRules`, protocol, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createDraft = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<number> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateDraft`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createDraftFromPecMail = (aooId: number, uorId: number, protocol: IProtocol, mailId: number, mailboxAddress: string, cancelToken?: CancelToken): Promise<number> => {
    const formData = getCreateProtocolFormData(protocol, mailboxAddress, mailId);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateDraftFromPecMail`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });

}

const createProtocol = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<number> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateProtocol`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
};


const createProtocolFromDraft = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<number> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateProtocolFromDraft/${protocol.protocolId}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createAllocatedProtocol = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<any> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateAllocatedProtocol`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });

    //const createAllocatedProtocolRequest: ICreateAllocatedProtocolRequest =
    //{
    //    attachments: protocol.attachments ? [...protocol.attachments] : [],
    //    fields: protocol.fields ? [...protocol.fields] : [],
    //    tipoProtocollo: protocol.tipoProtocollo ? protocol.tipoProtocollo : Protocol_Type.Undefined,
    //    titolario: protocol.titolario,
    //    visibilita: protocol.visibilita
    //};
    //return axiosInstance.post(`Protocols/${aooId}/${uorId}/CreateAllocatedProtocol`, createAllocatedProtocolRequest, { cancelToken: cancelToken })
    //    .then(result => result.data)
    //    .catch(error => {
    //        return Promise.reject(error);
    //    });
}

const updateAcquired = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<any> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateAcquired/${protocol.protocolId}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateProtocolDraft = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<any> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateProtocolDraft/${protocol.protocolId}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateProtocol = (aooId: number, uorId: number, protocolId: number, fields: IField[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateProtocol/${protocolId}`, fields, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateFilingPlanProtocol = (aooId: number, uorId: number, protocolId: number, titolario?: string, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.put(`Protocols/${aooId}/${uorId}/UpdateFilingPlanProtocol/${protocolId}`, undefined, { params: { titolario }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const updateVisibilitaProtocol = (aooId: number, uorId: number, protocolId: number, visibilita: IVisibilitaDTO[], cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/UpdateVisibilitaProtocol/${protocolId}`, visibilita, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const protocollaAcquired = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<number> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/ProtocollaAcquired/${protocol.protocolId}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });

}

const protocollaOAcquisisciAllocato = (aooId: number, uorId: number, protocol: IProtocol, cancelToken?: CancelToken): Promise<any> => {
    const formData = getCreateProtocolFormData(protocol);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/ProtocollaOAcquisisciAllocato/${protocol.protocolId}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteDraft = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`Protocols/${aooId}/${uorId}/DeleteDraft/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const undoProtocol = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<number> => {

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/Undo/${protocolId}`, null, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addAttachment = (aooId: number, uorId: number, protocolId: number, attachment: IFile, cancelToken?: CancelToken): Promise<number> => {
    const formData = getAddAttachmentFormData(attachment);

    return axiosInstance.post(`Protocols/${aooId}/${uorId}/AddAttachment/${protocolId}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                    (progressEvent.loaded * 100) / (progressEvent.total || 1)
                );
                console.log(`Upload progress: ${percentCompleted}%`);
            },
            cancelToken: cancelToken,
            timeout: 120000 // 2 minuti
        })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteAttachment = (aooId: number, uorId: number, protocolId: number, attachId: number, cancelToken?: CancelToken): Promise<number> => {

    return axiosInstance.delete(`Protocols/${aooId}/${uorId}/DeleteAttachment/${protocolId}/${attachId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const signDocumentPades = (aooId: number, uorId: number, protId: number, arubaRemoteSignRequest: Partial<IArubaRemoteSignRequest>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/${uorId}/SignDocumentPades/${protId}`, arubaRemoteSignRequest, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getSignatureForProtocol = (aooId: number, uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.get(`Protocols/${aooId}/${uorId}/GetSignatureForProtocol/${protocolId}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const getAnnotazioniProtocollo = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IAnnotazione[]> => {
    return axiosInstance.get(`Protocols/${aooId}/GetAnnotazioniProtocollo/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}
const addAnnotazioneProtocollo = (aooId: number, uorId: number | undefined, protocolId: number, annotazione: IAnnotazione, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`Protocols/${aooId}/AddAnnotazioneProtocollo/${protocolId}`, annotazione, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

/**
 * Converte un oggetto IFile (con file come stringa Base64 o array di numeri) in un oggetto IFile con File nativo
 */
const convertFileSPToIFile = (fileSP: IFile): IFile => {
    let fileName: string = fileSP.fileName ?? 'document.pdf';
    let fileExtension: string = fileSP.extension ?? '.pdf';

    // Verifica se fileByteArray è una stringa Base64
    if (fileSP.fileContent && typeof fileSP.fileContent === 'string') {
        // Decodifica Base64 in byte array
        const byteCharacters = atob(fileSP.fileContent);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const uint8Array = new Uint8Array(byteNumbers);

        // Crea un Blob
        const mimeType = Utilities.GetMimeType(fileName || fileExtension);
        const blob = new Blob([uint8Array], { type: mimeType });

        // Crea un File nativo
        const file = new File([blob], fileName || 'document.pdf', {
            type: mimeType
        });

        // Mappa a IFile
        return {
            id: fileSP.id,
            fileName: fileName,
            fileType: fileSP.fileType,
            idDocConservazione: fileSP.idDocConservazione,
            dimension: fileSP.dimension,
            dimensionUnit: fileSP.dimensionUnit,
            impronta: fileSP.impronta,
            originalName: fileSP.originalName,
            extension: fileExtension,
            file: file
        };
    }

    // Fallback per array di numeri
    if (fileSP.file && Array.isArray(fileSP.file)) {
        const uint8Array = new Uint8Array(fileSP.file);
        const mimeType = Utilities.GetMimeType(fileName || fileExtension);
        const blob = new Blob([uint8Array], { type: mimeType });

        const file = new File([blob], fileName || 'document.pdf', {
            type: mimeType
        });

        return {
            id: fileSP.id,
            fileName: fileName,
            fileType: fileSP.fileType,
            idDocConservazione: fileSP.idDocConservazione,
            dimension: fileSP.dimension,
            dimensionUnit: fileSP.dimensionUnit,
            impronta: fileSP.impronta,
            originalName: fileSP.originalName,
            extension: fileExtension,
            file: file
        };
    }

    if (fileSP.docBase64String && typeof fileSP.docBase64String === 'string') {
        // Decodifica Base64 in byte array
        const byteCharacters = atob(fileSP.docBase64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const uint8Array = new Uint8Array(byteNumbers);

        // Crea un Blob
        const mimeType = Utilities.GetMimeType(fileName || fileExtension);
        const blob = new Blob([uint8Array], { type: mimeType });

        // Crea un File nativo
        const file = new File([blob], fileName || 'document.pdf', {
            type: mimeType
        });

        // Mappa a IFile
        return {
            id: fileSP.id,
            fileName: fileName,
            fileType: fileSP.fileType,
            idDocConservazione: fileSP.idDocConservazione,
            dimension: fileSP.dimension,
            dimensionUnit: fileSP.dimensionUnit,
            impronta: fileSP.impronta,
            originalName: fileSP.originalName,
            extension: fileExtension,
            file: file
        };
    }
    // Se non è né Base64 né array, ritorna l'oggetto così com'è
    return fileSP;
};



// --- Mapper: IProtocol (modello UI) → IProtocolSavePayload (contratto API) ---

const toProtocolSavePayload = (protocol: IProtocol): IProtocolSavePayload => ({
    tipoProtocollo: protocol.tipoProtocollo,
    statoProtocollo: protocol.statoProtocollo,
    titolario: protocol.titolario,
    documentFile: protocol.documentFile?.fileName
        ? {
            id: protocol.documentFile.id,
            fileName: protocol.documentFile.fileName,
        }
        : undefined,
    attachments: protocol.attachments?.map(att => ({
        id: att.id,
        fileName: att.fileName,
    })),
    fields: protocol.fields?.map(f => ({
        internalName: f.internalName,
        internalValue: f.internalValue,
    })),
    visibilita: protocol.visibilita?.map(v => ({
        uor: { id: v.uor?.id!, aooId: v.uor?.aooId! },
        tipologia: v.tipologia,
    })),
});

const getCreateProtocolFormData = (
    protocol: IProtocol,
    mailboxAddress: string | undefined = undefined,
    mailId: number | undefined = undefined
): FormData => {
    const formData = new FormData();

    formData.append('protocol', JSON.stringify(toProtocolSavePayload(protocol)));

    if (mailboxAddress)
        formData.append('mailboxAddress', JSON.stringify(mailboxAddress));
    if (mailId)
        formData.append('mailId', JSON.stringify(mailId));

    if (protocol.documentFile?.file) {
        formData.append('mainDocument', protocol.documentFile.file, protocol.documentFile.fileName);
    } else if (protocol.documentFile?.fileName === 'Corpo della mail.pdf') {
        formData.append(
            'mainDocument',
            Utilities.ReturnEmptyFile(protocol.documentFile.fileName),
            protocol.documentFile.fileName
        );
    }

    protocol.attachments?.forEach((att, i) => {
        if (att.file)
            formData.append('attachments', att.file, att.fileName || `attachment_${i}`);
    });

    return formData;
}
const getAddAttachmentFormData = (attachment: IFile) => {
    const formData = new FormData();

    formData.append(
        'file',
        attachment.file!,
        attachment.fileName
    );

    return formData;
}

export default {
    getProtocolsUor,
    getProtocol,
    getVisibilitaProtocollo,
    getUserVisibilitaForProtocol,
    evaluateProtocolForwardRules,
    getProtocolDocumentFile,
    getFileByName,
    getFileById,
    getProtocolFilesAsZip,
    getAudit,
    getSummaryIA,
    addAttachment,
    deleteAttachment,
    createProtocol,
    createProtocolFromDraft,
    createDraft,
    createDraftFromPecMail,
    deleteDraft,
    updateProtocol,
    updateProtocolDraft,
    updateFilingPlanProtocol,
    updateVisibilitaProtocol,
    undoProtocol,
    signDocumentPades,
    updateAcquired,
    protocollaAcquired,
    createAllocatedProtocol,
    protocollaOAcquisisciAllocato,
    getSignatureForProtocol,
    getAnnotazioniProtocollo,
    addAnnotazioneProtocollo,
    convertFileSPToIFile
}



